import { AuthService } from "./../../shared/models/auth.service";
import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { PrePostTripQuestionModel } from "./pre-post-trip-question.model";
import { Observable } from "rxjs/Observable";
import { WeGoConfig, IAPIResponse, DataListModel } from "../../shared/config";
import { JQueryHelperService } from "../../shared/models/jquery-helper.service";
import { CustomeTripQuestion } from "./custom-question.model";

@Injectable()
export class PrePostTripQuestionService {
  private JQueryHelper: JQueryHelperService = new JQueryHelperService();
  constructor(private authService: AuthService, private http: Http) {}

  public GetPrePostQuestionsList(
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getPrePostQuestionListUrl = WeGoConfig.API_PRE_POST_TRIP_QUESTION_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getPrePostQuestionListUrl = getPrePostQuestionListUrl + "?" + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getPrePostQuestionListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetPrePostTripQuestionList(
    prePostTripQuestionModel: PrePostTripQuestionModel,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let url = WeGoConfig.API_PRE_POST_TRIP_QUESTION_DETAILS;
    let queryStringDataListModel = this.authService.HandleAPIListInput(input);
    let queryStringPrePostTripQuestionModel = this.JQueryHelper.Param(
      prePostTripQuestionModel
    );
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    url =
      url +
      "?" +
      queryStringDataListModel +
      "&" +
      decodeURIComponent(queryStringPrePostTripQuestionModel);
    return this.http
      .get(url, options)

      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public CheckCustomTripQuestion(
    customTripQuestionModel: CustomeTripQuestion
  ): Observable<IAPIResponse> {
    let body = customTripQuestionModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(WeGoConfig.API_PRE_POST_TRIP_QUESTION_CUSTOM, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UpdatePrePostTripQuestion(
    prePostTripQuestion: PrePostTripQuestionModel
  ): Observable<IAPIResponse> {
    let body = prePostTripQuestion;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(WeGoConfig.API_PRE_POST_TRIP_QUESTION_UPDATE, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetPrePostTripQuestionByHashId(
    prePostQuestionHashId: string
  ): Observable<IAPIResponse> {
    let getUrl =
      WeGoConfig.API_PRE_POST_TRIP_QUESTION_BY_HASHID +
      "?prePostQuestionHashId=" +
      prePostQuestionHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetPrePostQuestionById(
    prePostTripQuestionModel: PrePostTripQuestionModel
  ): Observable<IAPIResponse> {
    let url = WeGoConfig.API_PRE_POST_TRIP_QUESTION_BY_INSTANCEHASHID;
    let queryStringPrePostTripQuestionModel = this.JQueryHelper.Param(
      prePostTripQuestionModel
    );
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    url = url + "?" + decodeURIComponent(queryStringPrePostTripQuestionModel);
    return this.http
      .get(url, options)

      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/pre-post-trip-question/models/pre-post-trip-question.service.ts